import { Plan, PlanCategory, SubscriptionStatus } from '@/shared/types/Billing';

const DEFAULT_ENTERPRISE_SUBSCRIPTION_STATE = {
  hasEnterprisePlan: false,
  hasActiveEnterprisePlan: false,
  hasTrialingEnterprisePlan: false,
};

export const getEnterpriseSubscriptionState = (
  plans: Plan[],
  userPlanId?: string,
  subscriptionStatus?: SubscriptionStatus,
) => {
  if (!userPlanId || !subscriptionStatus) {
    return DEFAULT_ENTERPRISE_SUBSCRIPTION_STATE;
  }

  const hasEnterprisePlan =
    plans.filter((plan) => plan.id === userPlanId && plan.category === PlanCategory.Enterprise).length === 1;
  const hasActiveEnterprisePlan = hasEnterprisePlan && subscriptionStatus === SubscriptionStatus.Active;
  const hasTrialingEnterprisePlan = hasEnterprisePlan && subscriptionStatus === SubscriptionStatus.Trialing;

  return {
    hasEnterprisePlan,
    hasActiveEnterprisePlan,
    hasTrialingEnterprisePlan,
  };
};
